$(function(){
  $('.featured-collection__slider .product-grid').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.29004 7.4082L10.5665 4.11877L7.29004 0.829329" stroke="#0A0C2E" stroke-linecap="round" stroke-linejoin="round"/><path d="M0.737305 4.11865L10.5666 4.11865" stroke="#0A0C2E" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.29004 7.4082L10.5665 4.11877L7.29004 0.829329" stroke="#0A0C2E" stroke-linecap="round" stroke-linejoin="round"/><path d="M0.737305 4.11865L10.5666 4.11865" stroke="#0A0C2E" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.testimonials__wrapper').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $(".product__media-slider").slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<div class="arrow-left"><svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.41699 10.1616L0.791994 5.51827L5.41699 0.874929" stroke="#0A0C2E" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.667 5.51831L0.791998 5.51831" stroke="#0A0C2E" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
        nextArrow: '<div class="arrow-right"><svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.583 10.1616L15.208 5.51827L10.583 0.874929" stroke="#0A0C2E" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.33301 5.51831L15.208 5.51831" stroke="#0A0C2E" stroke-linecap="round" stroke-linejoin="round"/></svg><div>'
  });
  $(".thumbnail-list__item").click(function(){
    var i = $(this).data("media-position") - 1;
    $(".product__media-slider").slick("slickGoTo", i);
  });

  if($(window).width() < 750){
    $(".related-products .product-grid").slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });

    $(".multicolumn-list").slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }

  document.addEventListener('rebuy:cart.change', (event) => { 
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
          $(".cart-count-bubble span").text(cart.item_count);
        }
    });
  });

  $("#BackToTop").click(function(){
        $("html, body").animate({ scrollTop: 0 }, "slow");
  });
  
});

$(document).ready(function() {
	$('.popup-with-zoom-anim').magnificPopup({
		type: 'inline',

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: 'auto',

		closeBtnInside: true,
		preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in',

        callbacks: {
          open: function() {
            $('#image-with-text__video-popup video').trigger('play');
            $('.video-list__video video').trigger('play');
            $('body').css('overflow', 'hidden');
          },
          close: function() {
            $('#image-with-text__video-popup video').trigger('pause');
            $('.video-list__video video').trigger('pause');
            $('body').css('overflow', '');
          }
        }
	});
});